<app-stepper *ngIf="stepperMode" [service]="service"></app-stepper>
<form autocomplete="off">
  <div [formGroup]="form" *ngIf="!stepperMode">
    <div>
      <div fxFlex="" fxLayout="column" [class.custom]="field.form.formFieldType === 'img'">
        <ng-container [ngSwitch]="forcedFieldType || field.form.formFieldType">
          <ng-container *ngSwitchCase="'text'">
            <div class="field-container" [ngClass]="field?.form?.cssClass">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="required-asterisk inline">
                    *
                  </span>
                </mat-label>
                <div matPrefix *ngIf="field.form.prefix">
                  <ng-container *ngFor="let prefix of field.form.prefix">
                    <ng-container [ngSwitch]="prefix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ prefix.list.translate ? (prefix.list.staticText | translate) : prefix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <input
                  type="text"
                  matInput
                  [minlength]="field.form.minLength"
                  [maxlength]="field.form.maxLength"
                  [formControlName]="field.name"
                  (keypress)="type($event, field.form?.noSpaces)"
                />

                <div matSuffix *ngIf="field.form.suffix">
                  <ng-container *ngFor="let suffix of field.form.suffix">
                    <ng-container [ngSwitch]="suffix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ suffix.list.translate ? (suffix.list.staticText | translate) : suffix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <mat-hint align="start" *ngIf="field?.form?.hint">
                  <ng-container [ngSwitch]="field?.form?.hint?.list?.displayType">
                    <ng-container *ngSwitchCase="null">
                      <strong>
                        {{
                          field?.form?.hint?.list?.translate
                            ? (field?.form?.hint?.list?.staticText | translate)
                            : field?.form?.hint?.list?.staticText
                        }}
                      </strong>
                    </ng-container>
                    <ng-container *ngSwitchCase="'odometerLastUpdateFn'">
                      <strong>
                        {{ field?.form?.hint?.list?.fn() }}
                      </strong>
                    </ng-container>
                  </ng-container>
                </mat-hint>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'toggle'">
            <div class="field-container" [ngClass]="field?.form?.cssClass">
              <span style="margin-left: 10px;">{{
                cid + '.' + (field.form.name ? field.form.name : field.name) | translate
              }}</span>
              <mat-slide-toggle
                (change)="onChangeValue_ng_select(field, $event)"
                color="primary"
                [formControlName]="field.name"
              >
              </mat-slide-toggle>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'number'">
            <div class="field-container">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline">
                    *
                  </span>
                </mat-label>
                <div matSuffix *ngIf="field.form.prefix">
                  <ng-container *ngFor="let prefix of field.form.prefix">
                    <ng-container [ngSwitch]="prefix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ prefix.list.translate ? (prefix.list.staticText | translate) : prefix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <input
                  type="number"
                  matInput
                  [formControlName]="field.name"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                  [min]="field?.form?.minValue?.value"
                  [max]="field?.form?.maxValue?.value"
                />
                <div matSuffix *ngIf="field.form.suffix">
                  <ng-container *ngFor="let suffix of field.form.suffix">
                    <ng-container [ngSwitch]="suffix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ suffix.list.translate ? (suffix.list.staticText | translate) : suffix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <mat-hint align="start" *ngIf="field?.form?.hint">
                  <ng-container [ngSwitch]="field?.form?.hint?.list?.displayType">
                    <ng-container *ngSwitchCase="null">
                      <strong>
                        {{
                          field?.form?.hint?.list?.translate
                            ? (field?.form?.hint?.list?.staticText | translate)
                            : field?.form?.hint?.list?.staticText
                        }}
                      </strong>
                    </ng-container>
                    <ng-container *ngSwitchCase="'odometerLastUpdateFn'">
                      <strong>
                        {{ field?.form?.hint?.list?.fn() }}
                      </strong>
                    </ng-container>
                  </ng-container>
                </mat-hint>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'text_number'">
            <div class="field-container">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline">
                    *
                  </span>
                </mat-label>
                <div matSuffix *ngIf="field.form.prefix">
                  <ng-container *ngFor="let prefix of field.form.prefix">
                    <ng-container [ngSwitch]="prefix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ prefix.list.translate ? (prefix.list.staticText | translate) : prefix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <input
                  type="text"
                  [minlength]="field.form.minLength"
                  [maxlength]="field.form.maxLength"
                  min="0"
                  matInput
                  [formControlName]="field.name"
                  (keypress)="numberOnly($event, field)"
                  (input)="checkRangeValues($event, field, field.form.minValue?.value, field.form.maxValue?.value)"
                />
                <div matSuffix *ngIf="field.form.suffix">
                  <ng-container *ngFor="let suffix of field.form.suffix">
                    <ng-container [ngSwitch]="suffix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ suffix.list.translate ? (suffix.list.staticText | translate) : suffix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <mat-hint align="start" *ngIf="field?.form?.hint">
                  <ng-container [ngSwitch]="field?.form?.hint?.list?.displayType">
                    <ng-container *ngSwitchCase="null">
                      <strong>
                        {{
                          field?.form?.hint?.list?.translate
                            ? (field?.form?.hint?.list?.staticText | translate)
                            : field?.form?.hint?.list?.staticText
                        }}
                      </strong>
                    </ng-container>
                    <ng-container *ngSwitchCase="'odometerLastUpdateFn'">
                      <strong>
                        {{ field?.form?.hint?.list?.fn() }}
                      </strong>
                    </ng-container>
                  </ng-container>
                </mat-hint>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'float'">
            <div class="field-container">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline">
                    *
                  </span>
                </mat-label>
                <div matSuffix *ngIf="field.form.prefix">
                  <ng-container *ngFor="let prefix of field.form.prefix">
                    <ng-container [ngSwitch]="prefix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ prefix.list.translate ? (prefix.list.staticText | translate) : prefix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <input
                  type="text"
                  [minlength]="field.form.minLength"
                  [maxlength]="field.form.maxLength"
                  min="0"
                  matInput
                  [formControlName]="field.name"
                  (keypress)="writeFloatNumber($event)"
                />
                <div matSuffix *ngIf="field.form.suffix">
                  <ng-container *ngFor="let suffix of field.form.suffix">
                    <ng-container [ngSwitch]="suffix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ suffix.list.translate ? (suffix.list.staticText | translate) : suffix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <mat-hint align="start" *ngIf="field?.form?.hint">
                  <ng-container [ngSwitch]="field?.form?.hint?.list?.displayType">
                    <ng-container *ngSwitchCase="null">
                      <strong>
                        {{
                          field?.form?.hint?.list?.translate
                            ? (field?.form?.hint?.list?.staticText | translate)
                            : field?.form?.hint?.list?.staticText
                        }}
                      </strong>
                    </ng-container>
                    <ng-container *ngSwitchCase="'odometerLastUpdateFn'">
                      <strong>
                        {{ field?.form?.hint?.list?.fn() }}
                      </strong>
                    </ng-container>
                  </ng-container>
                </mat-hint>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'text_arabic'">
            <div class="field-container">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline">
                    *
                  </span>
                </mat-label>
                <div matSuffix *ngIf="field.form.prefix">
                  <ng-container *ngFor="let prefix of field.form.prefix">
                    <ng-container [ngSwitch]="prefix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ prefix.list.translate ? (prefix.list.staticText | translate) : prefix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <input
                  type="text"
                  [minlength]="field.form.minLength"
                  [maxlength]="field.form.maxLength"
                  min="0"
                  matInput
                  [formControlName]="field.name"
                  (keypress)="arabicOnly($event)"
                />
                <div matSuffix *ngIf="field.form.suffix">
                  <ng-container *ngFor="let suffix of field.form.suffix">
                    <ng-container [ngSwitch]="suffix.list.displayType">
                      <ng-container *ngSwitchCase="null">
                        {{ suffix.list.translate ? (suffix.list.staticText | translate) : suffix.list.staticText }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>

                <mat-hint align="start" *ngIf="field?.form?.hint">
                  <ng-container [ngSwitch]="field?.form?.hint?.list?.displayType">
                    <ng-container *ngSwitchCase="null">
                      <strong>
                        {{
                          field?.form?.hint?.list?.translate
                            ? (field?.form?.hint?.list?.staticText | translate)
                            : field?.form?.hint?.list?.staticText
                        }}
                      </strong>
                    </ng-container>
                    <ng-container *ngSwitchCase="'odometerLastUpdateFn'">
                      <strong>
                        {{ field?.form?.hint?.list?.fn() }}
                      </strong>
                    </ng-container>
                  </ng-container>
                </mat-hint>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'textarea'">
            <div class="field-container">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline">
                    *
                  </span>
                </mat-label>
                <textarea matInput [formControlName]="field.name"></textarea>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'colorPicker'">
            <div class="field-container color-picker-style1 ">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline"> *</span>
                </mat-label>
                <button
                  class="color-circle"
                  mat-mini-fab
                  tabindex="-1"
                  [style.background]="form.get(field.name).value ? form.get(field.name).value : '#fff'"
                  matPrefix
                  (click)="focusInputById(field.name)"
                ></button>
                <input
                  matInput
                  [id]="field.name"
                  autocomplete="off"
                  [formControlName]="field.name"
                  [cpWidth]="'160px'"
                  [cpPresetColors]="['#1862DB', '#FF9900', '#2EB8FF', '#FF0000', '#E5237F', '#13E9CC', '#7FFF00']"
                  [colorPicker]="form.get(field.name).value"
                  [value]="form.get(field.name).value"
                  [cpOutputFormat]="'hex'"
                  (colorPickerChange)="form.get(field.name).setValue($event)"
                  [cpPosition]="'bottom'"
                  [cpPositionRelativeToArrow]="false"
                />

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'password'">
            <div fxFlex fxLayout="column" class="field-container" [hidden]="field?.form?.hiddenEdit && isEdit">
              <div fxFlex fxLayout>
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>
                    <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                    <span *ngIf="checkRequiredFields(field.name)" class="required-asterisk inline"> *</span>
                  </mat-label>
                  <input
                    [type]="passwordHide ? 'password' : 'text'"
                    matInput
                    [formControlName]="field.name"
                    [minlength]="field.form.minLength"
                    [maxlength]="field.form.maxLength"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="passwordHide = !passwordHide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="passwordHide"
                    type="button"
                  >
                    <mat-icon>{{ passwordHide ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error>
                    <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                  </mat-error>
                </mat-form-field>
                <button
                  mat-icon-button
                  color="primary"
                  *ngIf="form.controls[field.name]?.disabled && isEdit && field?.form?.editDisabled"
                  class="edit"
                  (click)="enableControl(form.controls[field.name])"
                >
                  <mat-icon class="mat-18">edit</mat-icon>
                </button>
              </div>
            </div>
            <div fxFlex fxLayout [@showHide] *ngIf="!form.controls[field.name]?.disabled">
              <div class="password-guide" *ngIf="field?.hints?.password_helper">
                <ul>
                  <li
                    *ngIf="field?.hints?.minLength"
                    [ngClass]="{
                      success: !form.get(field?.name)?.errors?.minlength && !form.get(field?.name)?.errors?.required,
                      danger:
                        form.get(field?.name)?.errors?.minlength ||
                        (form.get(field?.name)?.errors?.required && form.get(field?.name)?.touched)
                    }"
                  >
                    <mat-icon
                      *ngIf="!form.get(field?.name)?.errors?.minlength && !form.get(field?.name)?.errors?.required"
                    >
                      check
                    </mat-icon>
                    <mat-icon
                      *ngIf="
                        form.get(field?.name)?.errors?.minlength ||
                        (form.get(field?.name)?.errors?.required && form.get(field?.name)?.touched)
                      "
                    >
                      close
                    </mat-icon>
                    <!--                                <div-->
                    <!--                                  *ngIf="!form.get(field?.name)?.touched || (!form.get(field?.name)?.dirty && form.get(field?.name)?.touched)"-->
                    <!--                                  class="square-icon"></div>-->
                    <span>{{ field?.hints?.minLength }} {{ 'validation_errors.characters' | translate }}</span>
                  </li>
                  <li
                    *ngIf="field?.hints?.hasSpecialCharacters"
                    [ngClass]="{
                      success:
                        !form.get(field?.name)?.errors?.hasSpecialCharacters &&
                        !form.get(field?.name)?.errors?.required,
                      danger:
                        form.get(field?.name)?.errors?.hasSpecialCharacters ||
                        (form.get(field?.name)?.errors?.required && form.get(field?.name)?.touched)
                    }"
                  >
                    <mat-icon
                      *ngIf="
                        !form.get(field?.name)?.errors?.hasSpecialCharacters && !form.get(field?.name)?.errors?.required
                      "
                    >
                      check
                    </mat-icon>
                    <mat-icon
                      *ngIf="
                        form.get(field?.name)?.errors?.hasSpecialCharacters ||
                        (form.get(field?.name)?.errors?.required && form.get(field?.name)?.touched)
                      "
                    >
                      close
                    </mat-icon>
                    <!--                                <div-->
                    <!--                                  *ngIf="!form.get(field?.name)?.touched || (!form.get(field?.name)?.dirty && form.get(field?.name)?.touched)"-->
                    <!--                                  class="square-icon"></div>-->
                    <span>{{ 'validation_errors.Special Character' | translate }}</span>
                    <span
                      *ngIf="
                        form.get(field?.name)?.errors?.hasSpecialCharacters ||
                        (form.get(field?.name)?.errors?.required && form.get(field?.name)?.touched)
                      "
                    >
                      {{ 'common.ex:' | translate }} {{ field?.hints?.hasSpecialCharacters }}
                    </span>
                  </li>
                  <li
                    *ngIf="field?.hints?.hasCapitalCase && field?.hints?.hasSmallCase && field?.hints?.hasNumber"
                    [ngClass]="{
                      success:
                        !form.get(field?.name)?.errors?.hasCapitalCase &&
                        !form.get(field?.name)?.errors?.hasNumber &&
                        !form.get(field?.name)?.errors?.hasSmallCase &&
                        !form.get(field?.name)?.errors?.required,
                      danger:
                        form.get(field?.name)?.errors?.hasCapitalCase ||
                        form.get(field?.name)?.errors?.hasNumber ||
                        form.get(field?.name)?.errors?.hasSmallCase ||
                        (form.get(field?.name)?.errors?.required && form.get(field?.name)?.touched)
                    }"
                  >
                    <mat-icon
                      *ngIf="
                        !form.get(field?.name)?.errors?.hasCapitalCase &&
                        !form.get(field?.name)?.errors?.hasNumber &&
                        !form.get(field?.name)?.errors?.hasSmallCase &&
                        !form.get(field?.name)?.errors?.required
                      "
                    >
                      check
                    </mat-icon>
                    <mat-icon
                      *ngIf="
                        form.get(field?.name)?.errors?.hasCapitalCase ||
                        form.get(field?.name)?.errors?.hasNumber ||
                        form.get(field?.name)?.errors?.hasSmallCase ||
                        (form.get(field?.name)?.errors?.required && form.get(field?.name)?.touched)
                      "
                    >
                      close
                    </mat-icon>
                    <!--                                <div-->
                    <!--                                  *ngIf="!form.get(field?.name)?.touched || (!form.get(field?.name)?.dirty && form.get(field?.name)?.touched)"-->
                    <!--                                  class="square-icon"></div>-->
                    <span>{{ 'validation_errors.Small letter & Capital letter & Number' | translate }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'confirmPassword'">
            <div fxFlex fxLayout="column" class="field-container" [@showHide] *ngIf="form.controls['password'].enabled">
              <div fxFlex fxLayout>
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>
                    <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                    <span class="required-asterisk inline"> *</span>
                  </mat-label>
                  <input [type]="confirmPasswordHide ? 'password' : 'text'" matInput [formControlName]="field.name" />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="confirmPasswordHide = !confirmPasswordHide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="confirmPasswordHide"
                    type="button"
                  >
                    <mat-icon>{{ confirmPasswordHide ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error>
                    <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- confirm password is always required -->
            </div>

            <div fxFlex fxLayout [@showHide] *ngIf="!form.controls['password']?.disabled">
              <div class="password-guide" *ngIf="field?.hints?.password_helper">
                <ul>
                  <li
                    *ngIf="field?.hints?.password_helper"
                    [ngClass]="{
                      success: !form.get(field?.name)?.errors?.passwordsDontMatch,
                      danger: form.get(field?.name)?.errors?.passwordsDontMatch
                    }"
                  >
                    <mat-icon *ngIf="!form.get(field?.name)?.errors?.passwordsDontMatch">
                      check
                    </mat-icon>
                    <mat-icon *ngIf="form.get(field?.name)?.errors?.passwordsDontMatch">
                      close
                    </mat-icon>
                    <!--                                <div-->
                    <!--                                  *ngIf="!form.get(field?.name)?.touched || (!form.get(field?.name)?.dirty && form.get(field?.name)?.touched)"-->
                    <!--                                  class="square-icon"></div>-->
                    <span>
                      {{ 'validation_errors.passwordsMatch' | translate }}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'email'">
            <div class="field-container">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline"> *</span>
                </mat-label>
                <input type="email" autocomplete="false" name="hidden" matInput [formControlName]="field.name" />

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'multi_select'">
            <div class="field-container">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline"> *</span>
                </mat-label>
                <mat-select [formControlName]="field.name" multiple>
                  <mat-option *ngFor="let item of service.lists[field.form.listPrefix]" [value]="item.id">
                    {{ item.name || item.displayName }}
                  </mat-option>
                </mat-select>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'ng_select_multiple'">
            <div
              class="field-container ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="true"
                bindLabel="name"
                bindValue="id"
                dropdownPosition="auto"
                [closeOnSelect]="false"
                [formControlName]="field.name"
                placeholder="{{ cid + '.' + field.name | translate }}"
                appendTo="body"
                appearance="outline"
              >
                <ng-template ng-header-tmp>
                  <div class="d-flex py-3">
                    <button
                      class="ml-2"
                      (click)="ngSelect_selectAll(form.controls[field.name], field.form.listPrefix, true)"
                      mat-stroked-button
                      color="primary"
                    >
                      {{ 'common.select_all' | translate }}
                    </button>
                    <button
                      (click)="ngSelect_selectAll(form.controls[field.name], field.form.listPrefix, false)"
                      mat-stroked-button
                      color="warn"
                    >
                      {{ 'common.unSelect_all' | translate }}
                    </button>
                  </div>
                </ng-template>

                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">{{ item.name || item.displayName }}</span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div class="d-flex align-items-center">
                    <mat-checkbox
                      class="d-inline-flex mr-3"
                      id="{{ item }}-option-{{ index }}"
                      color="primary"
                      [checked]="checkSelected(form.controls[field.name], item.id)"
                      (click)="preventDefault($event)"
                    >
                    </mat-checkbox>
                    <div class="d-inline-flex">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="d-inline-flex" [ngOptionHighlight]="search">
                      {{ item.name || item.displayName }}
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'custom_ng_select_multiple'">
            <div
              class="field-container ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="true"
                dropdownPosition="auto"
                [closeOnSelect]="false"
                [formControlName]="field.name"
                [searchFn]="searchInObject"
                placeholder="{{ cid + '.' + field.name | translate }}"
                appearance="outline"
                bindLabel="name"
                [appendTo]="field?.form?.appendTo"
                (change)="onChangeValue_ng_select(field, $event)"
                (scrollToEnd)="onScrollToEnd(field, $event)"
              >
                <ng-template ng-header-tmp>
                  <div class="d-flex py-3">
                    <button
                      class="ml-2"
                      (click)="ngSelect_selectAllPerObject(form.controls[field.name], field.form.listPrefix, true)"
                      mat-stroked-button
                      color="primary"
                    >
                      {{ 'common.select_all' | translate }}
                    </button>
                    <button
                      (click)="ngSelect_selectAllPerObject(form.controls[field.name], field.form.listPrefix, false)"
                      mat-stroked-button
                      color="warn"
                    >
                      {{ 'common.unSelect_all' | translate }}
                    </button>
                  </div>
                </ng-template>

                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }} - test
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">{{ item.name || item.displayName }}</span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div class="d-flex align-items-center">
                    <mat-checkbox
                      class="d-inline-flex mr-3"
                      id="{{ item }}-option-{{ index }}"
                      color="primary"
                      [checked]="checkObjectSelected(form.controls[field.name], item)"
                      (click)="preventDefault($event)"
                    >
                    </mat-checkbox>
                    <div class="">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="" [ngOptionHighlight]="search">
                      {{ item.name || item.displayName }}
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'ng_select_multiple_with_details'">
            <div
              class="field-container ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="true"
                bindLabel="name"
                bindValue="id"
                dropdownPosition="auto"
                [closeOnSelect]="false"
                [formControlName]="field.name"
                placeholder="{{ cid + '.' + field.name | translate }}"
                appearance="outline"
                [appendTo]="field?.form?.appendTo"
                dropdownPosition="bottom"
              >
                <ng-template ng-header-tmp>
                  <div class="d-flex py-3">
                    <button
                      class="ml-2"
                      (click)="ngSelect_selectAll(form.controls[field.name], field.form.listPrefix, true)"
                      mat-stroked-button
                      color="primary"
                    >
                      {{ 'common.select_all' | translate }}
                    </button>
                    <button
                      (click)="ngSelect_selectAll(form.controls[field.name], field.form.listPrefix, false)"
                      mat-stroked-button
                      color="warn"
                    >
                      {{ 'common.unSelect_all' | translate }}
                    </button>
                  </div>
                </ng-template>

                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">{{ item.name || item.displayName }}</span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div class="d-flex align-items-center">
                    <mat-checkbox
                      class="d-inline-flex mr-3"
                      id="{{ item }}-option-{{ index }}"
                      color="primary"
                      [checked]="checkSelected(form.controls[field.name], item.id)"
                      (click)="preventDefault($event)"
                    >
                    </mat-checkbox>
                    <div class="d-inline-flex">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="d-inline-flex" [ngOptionHighlight]="search">
                      {{ item.name || item.displayName }}
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
            <div class="selected_items">
              <span class="item" *ngFor="let id of form.controls[field.name].value">
                {{ getNameById(id, field.form.listPrefix) }}
                <mat-icon (click)="unSelect(id, field.name)">close</mat-icon></span
              >
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'ng_select_multiple_with_details_drag_and_drop'">
            <div
              class="field-container ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="true"
                bindLabel="name"
                bindValue="id"
                dropdownPosition="auto"
                [closeOnSelect]="false"
                [formControlName]="field.name"
                placeholder="{{ cid + '.' + field.name | translate }}"
                appearance="outline"
              >
                <ng-template ng-header-tmp>
                  <div class="d-flex py-3">
                    <button
                      class="ml-2"
                      (click)="ngSelect_selectAll(form.controls[field.name], field.form.listPrefix, true)"
                      mat-stroked-button
                      color="primary"
                    >
                      {{ 'common.select_all' | translate }}
                    </button>
                    <button
                      (click)="ngSelect_selectAll(form.controls[field.name], field.form.listPrefix, false)"
                      mat-stroked-button
                      color="warn"
                    >
                      {{ 'common.unSelect_all' | translate }}
                    </button>
                  </div>
                </ng-template>

                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">{{ item.name || item.displayName }}</span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div class="d-flex align-items-center">
                    <mat-checkbox
                      class="d-inline-flex mr-3"
                      id="{{ item }}-option-{{ index }}"
                      color="primary"
                      [checked]="checkSelected(form.controls[field.name], item.id)"
                      (click)="preventDefault($event)"
                    >
                    </mat-checkbox>
                    <div class="d-inline-flex">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="d-inline-flex" [ngOptionHighlight]="search">
                      {{ item.name || item.displayName }}
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
            <div class="selected_items">
              <span class="item" *ngFor="let id of form.controls[field.name].value">
                {{ getNameById(id, field.form.listPrefix) }}
                <mat-icon (click)="unSelect(id, field.name)">close</mat-icon></span
              >
            </div>

            <div
              *ngIf="form.controls[field.name].value && form.controls[field.name].value.length > 1"
              cdkDropList
              class="drag-drop-list"
              (cdkDropListDropped)="drop(form.controls[field.name].value, $event)"
            >
              <ng-container *ngFor="let dragId of form.controls[field.name].value; let i = index">
                <div class="drag-drop-box" cdkDrag>
                  <span class="sort_number">{{ i + 1 }}</span>
                  {{ getNameById(dragId, field.form.listPrefix) }}
                  <mat-icon svgIcon="reorder"></mat-icon>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'ng_added_select_multiple'">
            <div
              class="field-container ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [items]="service.lists[field.form.listPrefix]"
                [addTag]="addTagNameFn"
                [multiple]="true"
                [hideSelected]="true"
                [clearSearchOnAdd]="true"
                addTagText="اضافة {{ service.cid + '.' + field.name | translate }}  "
                bindLabel="name"
                bindValue="name"
                dropdownPosition="auto"
                [closeOnSelect]="false"
                [formControlName]="field.name"
                placeholder="{{ cid + '.' + field.name | translate }}"
                notFoundText="لم يتم ادخال كلمة"
                appearance="outline"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">{{ item.name || item.displayName }}</span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div class="d-flex align-items-center">
                    <!-- <mat-checkbox
                        class="d-inline-flex mr-3"
                        id="{{ item }}-option-{{ index }}"
                        color="primary"
                        [checked]="checkLabelSelected(form.controls[field.name], item.name)"
                        (click)="preventDefault($event)"
                      ></mat-checkbox> -->
                    <div class="d-inline-flex">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="d-inline-flex" [ngOptionHighlight]="search">
                      {{ item.name || item.displayName }}
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
            <!-- <div style="margin-bottom:100px">
                    Selected labels: {{form[field?.name].value }}
                </div> -->
          </ng-container>

          <ng-container *ngSwitchCase="'ng_tag_select'">
            <div
              class="ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="false"
                [addTag]="true"
                addTagText="اضافة {{ service.cid + '.' + field.name | translate }}  "
                dropdownPosition="bottom"
                [closeOnSelect]="true"
                [formControlName]="field.name"
                (keydown)="writeInSelect($event, field)"
                (change)="onChangeValue_ng_select(field, $event)"
                placeholder="{{ service.cid + '.' + field.name | translate }}"
                [appendTo]="field?.form?.appendTo"
                appearance="outline"
                [virtualScroll]="true"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">
                    {{ item }}
                  </span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'ng_select'">
            <div
              class="ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="false"
                bindLabel="name"
                bindValue="id"
                dropdownPosition="auto"
                [closeOnSelect]="true"
                [formControlName]="field.name"
                (change)="onChangeValue_ng_select(field, $event)"
                placeholder="{{ service.cid + '.' + field.name | translate }}"
                appearance="outline"
                [appendTo]="field?.form?.appendTo"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">
                    {{ item.name || item.displayName }}
                  </span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div class="d-flex align-items-center">
                    <div class="d-inline-flex">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="d-inline-flex" [ngOptionHighlight]="search">
                      {{ item?.name || item?.displayName }}
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'custom_ng_select'">
            <div
              class="ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="false"
                bindLabel="name"
                dropdownPosition="auto"
                [closeOnSelect]="true"
                [formControlName]="field.name"
                (change)="onChangeValue_ng_select(field, $event)"
                placeholder="{{ service.cid + '.' + field.name | translate }}"
                appearance="outline"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">
                    {{ item.name || item.displayName }}
                  </span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div class="d-flex align-items-center">
                    <div class="d-inline-flex">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="d-inline-flex" [ngOptionHighlight]="search">
                      {{ item?.name || item?.displayName }}
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
          </ng-container>

          <!-- if you want to show more than one line in select  -->
          <ng-container *ngSwitchCase="'ng_select_multi_lines'">
            <div
              class="ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="false"
                bindLabel="name"
                bindValue="id"
                dropdownPosition="auto"
                [closeOnSelect]="true"
                [formControlName]="field.name"
                (change)="onChangeValue_ng_select(field, $event)"
                placeholder="{{ service.cid + '.' + field.name | translate }}"
                appearance="outline"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">
                    {{ item.name || item.displayName }}
                  </span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div fxFlex fxLayout="column" fxLayoutAlign="center">
                    <div class="d-inline-flex">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="first_line" [ngOptionHighlight]="search">
                      {{ item?.name1 || item?.displayName }}
                    </div>
                    <div class="second_line" [ngOptionHighlight]="search">
                      {{ item?.name2 || item?.displayName }}
                    </div>
                    <div class="line"></div>
                  </div>
                </ng-template>
              </ng-select>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'ng_select_api'">
            <div
              class="field-container ng_select_container"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <app-ng-select-api
                [requiredAsterisk]="checkRequiredFields(field.name)"
                [item]="form?.get(field?.name)?.value"
                [service]="service"
                [form]="form"
                [isEdit]="isEdit"
                [field]="field"
                [isClone]="isClone"
                [formControlName]="field?.name"
                [name]="field?.name"
                [disabled]="(field?.form?.editDisabled && isEdit) || field?.form?.disabled"
                (valueChanged)="onChangeValue_ng_select($event?.field, $event?.event)"
              >
              </app-ng-select-api>

              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
          </ng-container>
          <!--
            if you want to show checkbox with dropdown list .
          if the checkbox value is true you can select from dropdown list.
          if not the select dropdown list is disabled
          -->
          <ng-container *ngSwitchCase="'ng_select_with_checkbox'">
            <p *ngIf="field?.form?.groupLabel">
              {{ service.cid + '.' + field.form.groupLabel | translate }} <span style="color: red;">*</span>
            </p>
            <div
              class="ng_select_container  ng_select_with_checkbox"
              [ngClass]="field?.form?.cssClass"
              [class.error]="
                (form.get(field?.name)?.touched || isSubmitted) &&
                form.get(field?.name)?.invalid &&
                form.get(field?.name)?.errors
              "
            >
              <mat-checkbox [checked]="form.get(field.name).value" (change)="enableDropDown($event, field)">{{
                service.cid + '.' + field.name | translate
              }}</mat-checkbox>
              <ng-select
                class="ng-select-style1"
                [ngClass]="{ 'required-asterisk-inline-before': checkRequiredFields(field.name) }"
                [items]="service.lists[field.form.listPrefix]"
                [multiple]="false"
                bindLabel="name"
                bindValue="id"
                dropdownPosition="auto"
                [closeOnSelect]="true"
                [formControlName]="field.name"
                (change)="onChangeValue_ng_select(field, $event)"
                placeholder="{{ service.cid + '.' + field?.form?.placeHolder | translate }}"
                appearance="outline"
                [disabled]="field.form?.disabled"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <div class="d-inline-flex">
                    <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                      <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                        <span class="ng_select_prefix" *ngIf="prefix?.prop">
                          <ng-container [ngSwitch]="prefix?.displayType">
                            <ng-container *ngSwitchCase="null">
                              <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                {{ item[prefix.prop] }}
                              </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'color'">
                              <span
                                class="cell-display-type color {{ prefix?.cssClass }}"
                                *ngIf="item[prefix.prop]"
                                [style.background-color]="item[prefix.prop]"
                              ></span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'img'">
                              <span class="cell-display-type img {{ prefix?.cssClass }}">
                                <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                <img
                                  class="img-placeholder"
                                  *ngIf="!item[prefix.prop]"
                                  src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                  alt=""
                                />
                              </span>
                            </ng-container>
                          </ng-container>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>

                  <span class="ng-value-label d-inline-flex">
                    {{ item.name || item.displayName }}
                  </span>
                  <span class="ng-value-icon right ml-2" (click)="clear(item)">
                    <mat-icon
                      fontSet="mdi"
                      fontIcon="mdi-close-circle"
                      class="mdi-icon"
                      [attr.size]="'14px'"
                    ></mat-icon>
                  </span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                  <div class="d-flex align-items-center">
                    <div class="d-inline-flex">
                      <ng-container *ngIf="field?.form?.ngSelectOptions?.prefix">
                        <ng-container *ngFor="let prefix of field?.form?.ngSelectOptions?.prefix">
                          <span class="ng_select_prefix" *ngIf="prefix?.prop">
                            <ng-container [ngSwitch]="prefix?.displayType">
                              <ng-container *ngSwitchCase="null">
                                <span class="cell-display-type text{{ prefix?.cssClass }}" *ngIf="item[prefix.prop]">
                                  {{ item[prefix.prop] }}
                                </span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'color'">
                                <span
                                  class="cell-display-type color {{ prefix?.cssClass }}"
                                  *ngIf="item[prefix.prop]"
                                  [style.background-color]="item[prefix.prop]"
                                ></span>
                              </ng-container>
                              <ng-container *ngSwitchCase="'img'">
                                <span class="cell-display-type img {{ prefix?.cssClass }}">
                                  <img class="img-data" *ngIf="item[prefix.prop]" [src]="item[prefix.prop]" alt="" />
                                  <img
                                    class="img-placeholder"
                                    *ngIf="!item[prefix.prop]"
                                    src="{{ prefix.placeHolder ? prefix.placeHolder : 'assets/image-placeholder.png' }}"
                                    alt=""
                                  />
                                </span>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ng-container>
                      </ng-container>
                    </div>

                    <div class="d-inline-flex" [ngOptionHighlight]="search">
                      {{ item?.name || item?.displayName }}
                    </div>
                  </div>
                </ng-template>
              </ng-select>
              <mat-error>
                <div class="mat-form-field-subscript-wrapper mat-error">
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </div>
              </mat-error>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'checkbox'">
            <div class="field-container d-flex" [ngClass]="field?.form?.cssClass">
              <mat-checkbox
                color="primary"
                class="d-flex
                  clearfix pt-2 pb-2"
                [formControlName]="field.name"
              >
                {{ cid + '.' + field.name | translate }}
              </mat-checkbox>

              <div matSuffix *ngIf="field.form.suffix" class="display-inline-flex">
                <ng-container *ngFor="let suffix of field.form.suffix">
                  <ng-container [ngSwitch]="suffix.form.displayType">
                    <ng-container *ngSwitchCase="'icon'">
                      {{ suffix.form.translate ? (suffix.form.staticText | translate) : suffix.form.staticText }}
                      <span class="cell-display-type icon">
                        <ng-container *ngIf="suffix.form.icon">
                          <ng-container [ngSwitch]="suffix.form.icon.type">
                            <ng-container *ngSwitchCase="'mdi'">
                              <mat-icon
                                [ngClass]="suffix.form.icon.cssClass"
                                class="mdi-icon"
                                [matTooltip]="tooltipConditions(suffix?.form?.icon?.tooltip, suffix?.form)"
                                [matTooltipDisabled]="!suffix?.form?.icon?.tooltip"
                                [attr.size]="suffix?.form?.icon?.size ? suffix?.form?.icon?.size : '12px'"
                                svgIcon="{{ suffix?.form?.icon?.name }}"
                              ></mat-icon>
                            </ng-container>
                            <ng-container *ngSwitchCase="null">
                              <mat-icon
                                [matTooltip]="tooltipConditions(suffix?.form?.icon?.tooltip, suffix?.form)"
                                [matTooltipDisabled]="!suffix?.form?.icon?.tooltip"
                              >
                                {{ suffix?.form?.icon?.name }}
                              </mat-icon>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="null">
                      {{ suffix.form.translate ? (suffix.form.staticText | translate) : suffix.form.staticText }}
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'checkboxs_list'">
            <app-checkboxs
              [formArrayName]="field.form.listPrefix"
              [isEdit]="isEdit"
              [firstForm]="form"
              [listPrefix]="field.form.listPrefix"
              [field]="field"
            ></app-checkboxs>
            <!-- <div class="field-container d-flex" [ngClass]="field?.form?.cssClass">
              <mat-checkbox color="primary" class="d-flex
                  clearfix pt-2 pb-2" [formControlName]="field.name">
                {{ cid + '.' + field.name | translate }}
              </mat-checkbox>


            </div> -->
          </ng-container>

          <ng-container *ngSwitchCase="'button_as_checkbox'">
            <div class="field-container d-flex" [ngClass]="field?.form?.cssClass">
              <button
                mat-stroked-button
                color="primary"
                (click)="form.controls[field.name].setValue(!form.controls[field.name].value)"
              >
                {{ cid + '.' + field.name | translate }}
              </button>
              <input style="display: none" type="checkbox" [formControlName]="field.name" />

              <div matSuffix *ngIf="field.form.suffix" class="display-inline-flex">
                <ng-container *ngFor="let suffix of field.form.suffix">
                  <ng-container [ngSwitch]="suffix.form.displayType">
                    <ng-container *ngSwitchCase="'icon'">
                      {{ suffix.form.translate ? (suffix.form.staticText | translate) : suffix.form.staticText }}
                      <span class="cell-display-type icon">
                        <ng-container *ngIf="suffix.form.icon">
                          <ng-container [ngSwitch]="suffix.form.icon.type">
                            <ng-container *ngSwitchCase="'mdi'">
                              <mat-icon
                                [ngClass]="suffix.form.icon.cssClass"
                                class="mdi-icon"
                                [matTooltip]="tooltipConditions(suffix?.form?.icon?.tooltip, suffix?.form)"
                                [matTooltipDisabled]="!suffix?.form?.icon?.tooltip"
                                [attr.size]="suffix?.form?.icon?.size ? suffix?.form?.icon?.size : '12px'"
                                svgIcon="{{ suffix?.form?.icon?.name }}"
                              ></mat-icon>
                            </ng-container>
                            <ng-container *ngSwitchCase="null">
                              <mat-icon
                                [matTooltip]="tooltipConditions(suffix?.form?.icon?.tooltip, suffix?.form)"
                                [matTooltipDisabled]="!suffix?.form?.icon?.tooltip"
                              >
                                {{ suffix?.form?.icon?.name }}
                              </mat-icon>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="null">
                      {{ suffix.form.translate ? (suffix.form.staticText | translate) : suffix.form.staticText }}
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'datepicker'">
            <div class="field-container">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>
                  <span>{{ cid + '.' + (field?.form?.name ? field?.form?.name : field?.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline"> *</span>
                </mat-label>
                <input
                  color="primary"
                  matInput
                  [matDatepicker]="picker"
                  [formControlName]="field.name"
                  autocomplete="off"
                  [max]="
                    (form?.controls)[field?.form?.dateOptions?.max?.prop]?.value
                      ? (form?.controls)[field?.form?.dateOptions?.max?.prop]?.value
                      : field?.form?.dateOptions?.max?.staticValue
                      ? field?.form?.dateOptions?.max?.staticValue
                      : null
                  "
                  [min]="
                    (form?.controls)[field?.form?.dateOptions?.min?.prop]?.value
                      ? (form?.controls)[field?.form?.dateOptions?.min?.prop]?.value
                      : field?.form?.dateOptions?.min?.staticValue
                      ? field?.form?.dateOptions?.min?.staticValue
                      : null
                  "
                  (click)="picker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <mat-icon matDatepickerToggleIcon svgIcon="calendar-month"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'timepicker'">
            <div class="field-container">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label fxFlex="row" fxLayout>
                  <div fxFlex="95">
                    <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                    <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline"> *</span>
                  </div>
                </mat-label>
                <input color="primary" matInput [ngxTimepicker]="picker" [formControlName]="field.name" />
                <mat-icon matSuffix fxFlex="" class="mdi-icon time-picker-icon" svgIcon="clock-start"></mat-icon>
                <ngx-material-timepicker #picker></ngx-material-timepicker>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'dateTimeInput'">
            <app-date-time
              *ngIf="form.controls[field.name]"
              [cid]="cid"
              [field]="field"
              [form]="form"
              [key]="field.name"
              [service]="service"
              [isEdit]="isEdit"
              [minEntryDate]=""
              [maxEntryDate]=""
            >
            </app-date-time>

            <mat-error>
              <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
            </mat-error>
          </ng-container>

          <ng-container *ngSwitchCase="'dateTimeRangeInput'">
            <app-date-time-range
              *ngIf="form.controls[field.name]"
              [cid]="cid"
              [field]="field"
              [form]="form"
              [key]="field.name"
              [service]="service"
              [isEdit]="isEdit"
            >
            </app-date-time-range>

            <mat-error>
              <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
            </mat-error>
          </ng-container>

          <ng-container *ngSwitchCase="'select'">
            <div class="field-container">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                  <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline"> *</span>
                </mat-label>
                <mat-select [formControlName]="field.name">
                  <mat-option *ngFor="let item of service.lists[field.form.listPrefix]" [value]="item.id">
                    {{ item.name || item.displayName }}
                  </mat-option>
                </mat-select>

                <mat-error>
                  <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'radio'">
            <div class="field-container radio-group">
              <label class="d-flex clearfix pt-2 pb-2">
                <span>{{ cid + '.' + (field.form.name ? field.form.name : field.name) | translate }}</span>
                <span *ngIf="checkRequiredFields(field.name)" class="mat-error required-asterisk inline"> *</span>
              </label>

              <mat-radio-group
                [ngClass]="field?.form?.cssClass"
                [formControlName]="field.name"
                aria-label="Select an option"
              >
                <mat-radio-button
                  color="primary"
                  *ngFor="let item of service.lists[field.form.listPrefix]"
                  [value]="item.id"
                >
                  {{ item.name || item.displayName }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </ng-container>

          <!--        <ng-container *ngSwitchCase="'color_picker'">-->
          <!--          <div-->
          <!--            style="width: 400px;  display: flex;  flex-direction: column;  align-items: center; justify-content: center;"-->
          <!--          >-->
          <!--            <input-->
          <!--              style="height: 60px;  width: 60px;  border-radius: 50%; margin: 5px 0; border: none;  text-align: center;"-->
          <!--              [matTooltip]="'common.click_to_change' | translate"-->
          <!--              [formControlName]="field.name"-->
          <!--              [colorPicker]="form.controls[field.name].value"-->
          <!--              (colorPickerChange)="setColor(field.name, $event)"-->
          <!--              [style.background]="form.controls[field.name].value || '#e3e3e3'"-->
          <!--            />-->
          <!--            <label>{{ cid + '.' + field.name | translate }}</label>-->
          <!--          </div>-->

          <!--          <mat-error>-->
          <!--            <ng-container *ngTemplateOutlet="validationErrors"></ng-container>-->
          <!--          </mat-error>-->

          <!--        </ng-container>-->

          <ng-container *ngSwitchCase="'file_input'">
            <div class="field-container">
              <div style="display: flex;" *ngIf="form.controls[field.name]?.value">
                <img
                  width="300"
                  [src]="form.controls[field.name]?.valueChanges ? previewImage : form.controls[field.name]?.value"
                  [alt]="field?.name"
                />
              </div>
              <div style="width: 400px; display: flex; flex-direction: column">
                <label
                  style="width: 100%; border-radius: 10px; border: 1px dashed #2A3348; margin: 10px 0; padding: 10px; text-align: center"
                  for="file"
                  >{{ cid + '.' + field?.name | translate }}</label
                >
                <input
                  style="width: 0.1px; height: 0.1px;"
                  id="file"
                  type="file"
                  [formControlName]="field.name"
                  (change)="uploadPhoto($event, field)"
                />
              </div>

              <mat-error>
                <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
              </mat-error>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'img'">
            <div
              class="fileUpload image-upload field-container"
              [ngClass]="{ disabled: form.get(field?.name)?.disabled }"
            >
              <div class="image-container">
                <div class="buttons-container">
                  <button
                    mat-mini-fab
                    *ngIf="form.controls[field.name]?.value !== null"
                    class="delete"
                    (click)="clearImage(form.controls[field.name])"
                  >
                    <mat-icon color="primary" class="mdi-icon" svgIcon="delete-outline" [attr.size]="'14px'"></mat-icon>
                  </button>

                  <!--                  *ngIf="form.controls[field.name]?.disabled && isEdit && field?.form?.editDisabled"-->
                  <button
                    mat-mini-fab
                    class="edit"
                    (click)="openFileSelectFromInput(form.controls[field.name], field.name)"
                  >
                    <mat-icon color="warn" class="mdi-icon" svgIcon="pencil-outline" [attr.size]="'14px'"></mat-icon>
                  </button>
                </div>

                <img class="img-fluid" [src]="checkImgSrc(field)" [alt]="field?.name" />
                <!--              <span class="img-label" *ngIf="!form.controls[field.name]?.value">{{-->
                <!--                field?.form?.placeHolderText-->
                <!--                  ? (field?.form?.placeHolderText | translate)-->
                <!--                  : ('common.upload_photo' | translate)-->
                <!--              }}</span>-->
              </div>
              <div class="input-container">
                <label *ngIf="!form.controls[field.name]?.disabled" [@showHide] [for]="field.name">
                  <!--                              {{ cid + '.' + field?.name | translate }}-->
                </label>
                <input
                  [disabled]="form.controls[field.name]?.disabled"
                  class="upload-file-hidden"
                  [id]="field.name"
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  (change)="uploadPhoto($event, field, form.controls[field.name].value)"
                />
                <input type="hidden" [formControlName]="field.name" />
              </div>
              <!--                        <button-->
              <!--                          mat-raised-button-->
              <!--                          color="primary"-->
              <!--                          *ngIf="form.controls[field.name]?.enabled && isEdit && field?.form?.editDisabled"-->
              <!--                          class="edit"-->
              <!--                          (click)="uploadNewPhoto(form.controls[field.name].value , field)"-->
              <!--                        >-->
              <!--                          {{ 'common.upload' | translate }}-->
              <!--                        </button>-->
            </div>
          </ng-container>

          <ng-container *ngIf="field.form.formFieldType === 'permissions'">
            <app-permissions
              [service]="service"
              [item]="form?.get(field?.name)?.value"
              [form]="form"
              [isEdit]="isEdit"
              [isClone]="isClone"
              (UpdateFormFieldValue)="UpdateFormFieldValue($event, field)"
            ></app-permissions>
            <input type="hidden" [formControlName]="field?.name" />
          </ng-container>

          <ng-container *ngSwitchCase="'file_upload'">
            <div class="field-container input-container">
              <label *ngIf="!form.controls[field.name]?.disabled" [@showHide] [for]="field.name">
                <!--              {{ cid + '.' + field?.name | translate }}-->
              </label>
              <input
                class="input-file"
                type="file"
                accept="*/*"
                [id]="field.name"
                (change)="uploadFile($event, field)"
              />
              <input type="hidden" [formControlName]="field.name" />
              <div style="display: inline-block; position: absolute">
                <mat-icon class="mdi-icon" svgIcon="file-document-box-plus-outline" [attr.size]="'20px'"></mat-icon>
              </div>
              <div style="display: inline-block; margin-left: 35px; margin-top: -2px">
                <span style="font-size: 12px; color: #97A5CB;">{{ 'documents.click' | translate }}</span>
              </div>
              <div>
                <button mat-button class="browse">{{ 'documents.browse' | translate }}</button>
              </div>

              <mat-error>
                <ng-container *ngTemplateOutlet="validationErrors"></ng-container>
              </mat-error>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'file_download_details'">
            <div class="field-container file_download_details" *ngIf="(form?.controls)[field?.name]?.value">
              <div fxFlex="" fxLayout="row" class="d-flex align-items-center justify-content-center">
                <a
                  class="d-flex align-items-center justify-content-center"
                  mat-button
                  [href]="(form?.controls)[field?.name]?.value"
                >
                  <mat-icon
                    matPrefix
                    svgIcon="file-download-outline"
                    class="mdi-icon d-inline-flex align-items-center justify-content-center"
                    [attr.size]="'14px'"
                  >
                  </mat-icon>
                  <span class="primary-label">
                    {{ 'common.download_file' | translate }}
                  </span>
                </a>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'file_upload_details'">
            <div class="field-container file_upload_details" [ngClass]="{ disabled: form.get(field?.name)?.disabled }">
              <div
                fxFlex=""
                fxLayout="row"
                class="input-container d-flex align-items-center justify-content-flex-start position-relative"
              >
                <div class="icon">
                  <mat-icon svgIcon="file-document-box-plus-outline" [attr.size]="'14px'"></mat-icon>
                </div>
                <div fxLayout="column" class="labels" *ngIf="!selectedFiles[field?.name]">
                  <span class="primary-label">
                    {{ 'common.drop_files' | translate }}
                  </span>
                  <span class="secondary-label">
                    {{ 'common.pick_files' | translate }}
                  </span>
                </div>

                <div fxLayout="column" class="labels" *ngIf="selectedFiles[field?.name]">
                  <span class="primary-label">
                    {{ selectedFiles[field?.name]?.name }}
                  </span>
                  <span class="secondary-label">
                    {{ 'common.size' | translate }}
                    {{ selectedFiles[field?.name]?.size }} Kb
                  </span>
                </div>

                <div class="action-button">
                  <button mat-flat-button color="primary" class="upload_button">
                    {{ 'common.browse' | translate }}
                  </button>
                </div>
                <input
                  [disabled]="(form?.controls)[field?.name]?.disabled"
                  class="upload-file-hidden"
                  [id]="field.name"
                  type="file"
                  accept="*/*"
                  (change)="uploadFile($event, field)"
                />
                <div
                  *ngIf="isEdit && (form?.controls)[field?.name]?.disabled"
                  class="upload-file-hidden edit"
                  (click)="openFileSelectFromInput(form.controls[field.name], field.name)"
                ></div>
                <input type="hidden" [formControlName]="field?.name" />
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'map_points_select'">
            <app-draw-map [form]="form" [field]="field" [controlName]="field?.name"></app-draw-map>
          </ng-container>

          <!--  validation-errors  -->
          <ng-template #validationErrors>
            <ng-container *ngIf="getFormControl(field?.name)?.errors">
              <!--        <ng-container >-->
              <div
                class="validation-errors"
                *ngIf="
                  (getFormControl(field?.name)?.touched || isSubmitted) &&
                  getFormControl(field?.name)?.invalid &&
                  getFormControl(field?.name)?.errors
                "
              >
                <div class="mat-error" *ngFor="let error of getFormControl(field?.name)?.errors | pairs">
                  <!-- Server Side Errors -->
                  <ng-container *ngIf="error?.key === 'serverError'">
                    <ng-container *ngFor="let err of error.value">
                      {{ err }}
                    </ng-container>
                  </ng-container>

                  <!-- Client Side Errors-->
                  <ng-container *ngIf="error?.key !== 'serverError'">
                    <ng-container *ngIf="!field?.hints?.password_helper">
                      <ng-container [ngSwitch]="error?.key">
                        <ng-container *ngSwitchCase="'minlength'">
                          {{
                            'validation_errors.' + error.key
                              | translate
                                : {
                                    xx: error?.value?.requiredLength,
                                    type:
                                      (field?.form?.formFieldType === 'text_number' || field?.form?.numberOnly
                                        ? 'common.number'
                                        : 'common.text'
                                      ) | translate
                                  }
                          }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'maxlength'">
                          {{
                            'validation_errors.' + error.key
                              | translate
                                : {
                                    xx: error?.value?.requiredLength,
                                    type:
                                      (field?.form?.formFieldType === 'text_number' || field?.form?.numberOnly
                                        ? 'common.number'
                                        : 'common.text'
                                      ) | translate
                                  }
                          }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'pattern'">
                          {{
                            cid + '.' + 'validation_errors.' + error.key
                              | translate: { xx: error?.value?.requiredLength }
                          }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          {{ 'validation_errors.' + error.key | translate }}
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</form>
